import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const swiper = new Swiper(".case-studies-slider-container", {
  modules: [Navigation],
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 0,
  keyboard: {
    enabled: true,
  },
  navigation: {
    nextEl: '.case-studies-slider_actions-next',
    prevEl: '.case-studies-slider_actions-prev',
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 50,
    },
  },
});
